export default function CheckMark() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
      <path
        d="M1.83594 8.04192L4.55201 11.534C4.64366 11.6531 4.7611 11.7499 4.8955 11.8171C5.0299 11.8843 5.17778 11.9202 5.32803 11.922C5.47586 11.9238 5.62222 11.8924 5.75646 11.8305C5.89069 11.7686 6.00944 11.6774 6.10405 11.5638L14.7696 1.07764"
        stroke="#183344"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
